import { createSelector } from "reselect";

const selectAward = state => state.award;

export const selectAwardCollection = createSelector(
    [selectAward],
    award => award.collection
);